/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteAddress$Params {
  id: string;
  type: 'FIRM' | 'DEPARTMENT' | 'BOOK';
  entityId: string;
}

export function deleteAddress(http: HttpClient, rootUrl: string, params: DeleteAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteAddress.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('type', params.type, {});
    rb.query('entityId', params.entityId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteAddress.PATH = '/api/addresses/{id}';
